import React from "react";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { adminUsersApi, AdminUserRow, accessRolesApi, AccessRoleRow } from "./api";

/** Port of ApiV2/App/Controller/UsersController.php (v3/Users/edit-user.php list view).
 * Reads/writes the central Admin DB (AdminLoginDetails) - deferred shared infra in this
 * environment, same as /api/auth/login; see MIGRATION.md § Admin/Users/Roles. */
export function UsersPage() {
  const list = useQuery({ queryKey: ["admin", "users"], queryFn: () => adminUsersApi.list() });
  return (
    <>
      <PageHeader title="Users" location="Admin" />
      <div className="card" data-testid="admin-users-page"><div className="card-body">
        <ErpTable<AdminUserRow> rows={list.data?.Data || []} loading={list.isLoading}
          error={list.isError ? errorText(list.error) : null} testId="admin-users-table"
          columns={[{ key: "UserID", title: "User ID" }, { key: "UserName", title: "User Name" },
            { key: "ClientID", title: "Client" }, { key: "AccessType", title: "Access Type" },
            { key: "UserRoleID", title: "Role ID" },
            { key: "Status", title: "Status", render: (r) => (r.Status === 1 ? "Active" : "Inactive") }]} />
      </div></div>
    </>
  );
}

/** Port of ApiV2/App/Controller/AccessRolesListController.php (v3/Users/edit-roles.php list view). */
export function AccessRolesPage() {
  const list = useQuery({ queryKey: ["admin", "access-roles-list"], queryFn: () => accessRolesApi.list() });
  return (
    <>
      <PageHeader title="Access Roles" location="Admin" />
      <div className="card" data-testid="admin-access-roles-page"><div className="card-body">
        <ErpTable<AccessRoleRow> rows={list.data?.Data || []} loading={list.isLoading}
          error={list.isError ? errorText(list.error) : null} testId="admin-access-roles-table"
          columns={[{ key: "ID", title: "Role ID" }, { key: "RoleName", title: "Role Name" },
            { key: "HeaderNames", title: "Menu Access" }, { key: "SubHeaderNames", title: "Sub-menu Access" },
            { key: "EditAccess", title: "Edit Access", render: (r) => (r.EditAccess === 1 ? "Yes" : "No") },
            { key: "DeleteAccess", title: "Delete Access", render: (r) => (r.DeleteAccess === 1 ? "Yes" : "No") }]} />
      </div></div>
    </>
  );
}
